import { Feed, Stream } from 'interfaces'
import { connect } from 'react-redux'
import { from } from 'rxjs'
import { catchError, mergeMap } from 'rxjs/operators'
import { clearSelectedFeedsToSave } from 'services/content'
import { addFeeds, deleteFeed } from 'services/content/feeds/actions'
import { clearFeedToSave, trackFeedInteraction } from 'services/content/recommended/actions'
import { selectedFeedsToSaveSelector, userFeedsSelector, userStreamsSelector } from 'services/content/selectors'
import { createStream, getStreams, getUserStream } from 'services/content/streams/actions'
import { checkFeatureAvailability } from 'services/product'
import { message } from 'services/snackbar'
import { SnackType } from 'services/snackbar/interfaces/PendingTreat'
import { currentUserSelector } from 'services/users/selectors'
import StoreState, { StoreThunkDispatch } from 'store/state'
import { SaveFeedDialog } from './SaveFeedDialog'

const mapStateToProps = (state: StoreState) => ({
  selectedFeeds: selectedFeedsToSaveSelector(state) as Feed[],
  streams: userStreamsSelector(state),
  feeds: userFeedsSelector(state),
  userId: currentUserSelector(state)?.userId
})

const mapDispatchToProps = (dispatch: StoreThunkDispatch) => ({
  addFeeds: (feeds: Feed[], stream: Stream) => from(dispatch(addFeeds({ feeds, stream })).unwrap())
    .pipe(
      mergeMap(() => from(dispatch(getUserStream({ streamId: stream.id, force: true })).unwrap())),
      catchError((error: Error) => {
        dispatch(message('Error saving feeds: ' + error.message, 'error'))
        return from(dispatch(getUserStream({ streamId: stream.id, force: true })).unwrap())
      })
    ),
  createStream: (
    name: string,
    color?: string,
    feeds?: Feed[],
    isPrivate?: boolean,
    file?: File,
    featuredImage?: string,
    secondaryImages?: string[]
  ) => {
    return dispatch(createStream({ name, id: undefined, color, feeds, isPrivate, file, featuredImage, secondaryImages })).unwrap()
  },
  removeFeed: (id: string) => from(dispatch(deleteFeed({ feedId: id })).unwrap()),
  getUserStreams: (force?: boolean) => dispatch(getStreams(force)).unwrap(),
  onClose: () => {
    dispatch(clearFeedToSave())
    dispatch(clearSelectedFeedsToSave())
  },
  trackFeedInteraction: (ids: string[]) => dispatch(trackFeedInteraction({ feedIds: ids, event: 'open' })).unwrap(),
  checkFeatureAvailability: (feature: string) => dispatch(checkFeatureAvailability(feature)),
  displayNotification: (text: string, type?: SnackType) => dispatch(message(text, type))
})

const ConnectedSaveFeedDialog = connect(mapStateToProps, mapDispatchToProps)(SaveFeedDialog)
export default ConnectedSaveFeedDialog
